import { create } from "zustand";

const useMicSettings = create((set) => ({
  inputDevice: null,
  outputDevice: null,

  inputDevices: [],
  outputDevices: [],

  setInputDevice: (deviceId) =>
    set((state) => ({
      ...state,
      inputDevice: state.inputDevices.find((dev) => dev.deviceId === deviceId),
    })),
  setOutputDevice: (deviceId) =>
    set((state) => ({
      ...state,
      outputDevice: state.outputDevices.find(
        (dev) => dev.deviceId === deviceId
      ),
    })),

  setAudioDevices: (devices) =>
    set((state) => ({
      ...state,
      inputDevices: devices.filter((dev) => dev.kind === "audioinput"),
      outputDevices: devices.filter((dev) => dev.kind === "audiooutput"),
      inputDevice: devices.filter((dev) => dev.kind === "audioinput")[0],
      outputDevice: devices.filter((dev) => dev.kind === "audiooutput")[0],
    })),
}));

export default useMicSettings;
